import ScrollMagic from 'scrollmagic';
import * as GSAP from 'gsap';

document.addEventListener("DOMContentLoaded", function (event) {
    console.log(ScrollMagic);
    console.log(GSAP);
    createController();
    createKVEffect();
    createPromoEffect();
    createCTAEffect();
});

/*
* Controller
* */
let controller = null;

function createController() {
    controller = new ScrollMagic.Controller();
}


/*
* KV
* */
const kvSection = document.querySelector('.kv');

function createKVEffect() {

    const kvTrigger = kvSection.querySelector('.kv_trigger');
    const sceneKVS1 = new ScrollMagic.Scene({
        triggerElement: kvTrigger,
        triggerHook: 0.5,
        duration: kvTrigger.clientHeight
    })
        .on('enter', () => {
            transitionInKVS1();
        })
        .on('leave', () => {
            // resetKVS1();
        })
        .addTo(controller);

    resetKVS1();
}

function resetKVS1() {
    const gBack = kvSection.querySelector('.kv_graphic-back');
    const gFront = kvSection.querySelector('.kv_graphic-front');
    const product = kvSection.querySelector('.kv_product');
    const title = kvSection.querySelector('.kv_title');
    GSAP.TweenMax.set(gFront, {
        alpha: 0,
        scale: 1.5
    });
    GSAP.TweenMax.set(gBack, {
        alpha: 0,
        scale: 1.5
    });
    GSAP.TweenMax.set(product, {
        alpha: 0,
        yPercent: 20
    });
    GSAP.TweenMax.set(title, {
        alpha: 0
    });
}

function transitionInKVS1() {
    const gBack = kvSection.querySelector('.kv_graphic-back');
    const gFront = kvSection.querySelector('.kv_graphic-front');
    const product = kvSection.querySelector('.kv_product');
    const title = kvSection.querySelector('.kv_title');

    GSAP.TweenMax.to(gFront, 1.7, {
        delay: 0.3,
        alpha: 1,
        scale: 1,
        transformOrigin: 'center center',
        ease: GSAP.Power2.easeOut
    });
    GSAP.TweenMax.to(gBack, 1.7, {
        delay: 0.3,
        alpha: 1,
        scale: 1,
        transformOrigin: 'center center',
        ease: GSAP.Power2.easeOut
    });
    GSAP.TweenMax.to(product, {
        delay: 1,
        alpha: 1,
        yPercent: 0,
        ease: GSAP.Quad.easeOut
    });
    GSAP.TweenMax.to(title, {
        delay: 1,
        alpha: 1,
        ease: GSAP.Quad.easeOut
    });
}


/*
* Promo
* */
const promoSection = document.querySelector('.promotion');
const promoS1 = promoSection.querySelector('.promotion-s1');
const promoS2 = promoSection.querySelector('.promotion-s2');
const promoS3 = promoSection.querySelector('.promotion-s3');

function createPromoEffect() {
    const promoS1 = promoSection.querySelector('.promotion-s1');
    const promoS2 = promoSection.querySelector('.promotion-s2');
    const promoS3 = promoSection.querySelector('.promotion-s3');

    let isS1In = false;
    const scenePromoS1 = new ScrollMagic.Scene({
        triggerElement: promoS1,
        triggerHook: 0.7,
        duration: promoS1.clientHeight
    })
        .on('enter', () => {
            if (!isS1In) {
                isS1In = true;
                transitionInPromoS1();
            }
        })
        .addTo(controller);

    let isS2In = false;
    const scenePromoS2 = new ScrollMagic.Scene({
        triggerElement: promoS2,
        triggerHook: 0.7,
        duration: promoS2.clientHeight
    })
        .on('enter', () => {
            if (!isS2In) {
                isS2In = true;
                transitionInPromoS2();
            }
        })
        .addTo(controller);

    let isS3In = false;
    const scenePromoS3 = new ScrollMagic.Scene({
        triggerElement: promoS3,
        triggerHook: 0.7,
        duration: promoS3.clientHeight
    })
        .on('enter', () => {
            if (!isS3In) {
                isS3In = true;
                transitionInPromoS3();
            }
        })
        .addTo(controller);

    resetPromoS1();
    resetPromoS2();
    resetPromoS3();
}

function resetPromoS1() {
    const graphic = promoS1.querySelector('.promotion_graphic');
    const product = promoS1.querySelector('.promotion_product');
    const productInfo = promoS1.querySelector('.promotion_product_info');
    const productInfoLabel = promoS1.querySelector('.promotion_info_label');
    const productInfoTitle = promoS1.querySelector('.promotion_info_title');
    const productInfoDesc = promoS1.querySelector('.promotion_info_desc');
    const productInfoList = promoS1.querySelector('.promotion_info_list');
    GSAP.TweenMax.set(graphic, {
        xPercent: 20,
        scale: 2,
        alpha: 0
    });
    GSAP.TweenMax.set(product, {
        alpha: 0,
        xPercent: -10
    });
    GSAP.TweenMax.set(productInfo, {
        alpha: 0,
        xPercent: -10
    });
    GSAP.TweenMax.set(productInfoLabel, {
        alpha: 0,
        yPercent: 50
    });
    GSAP.TweenMax.set(productInfoTitle, {
        alpha: 0,
        yPercent: 50
    });
    GSAP.TweenMax.set(productInfoDesc, {
        alpha: 0,
        yPercent: 50
    });
    GSAP.TweenMax.set(productInfoList, {
        alpha: 0,
    });
}

function transitionInPromoS1() {
    const graphic = promoS1.querySelector('.promotion_graphic');
    const product = promoS1.querySelector('.promotion_product');
    const productInfo = promoS1.querySelector('.promotion_product_info');
    const productInfoLabel = promoS1.querySelector('.promotion_info_label');
    const productInfoTitle = promoS1.querySelector('.promotion_info_title');
    const productInfoDesc = promoS1.querySelector('.promotion_info_desc');
    const productInfoList = promoS1.querySelector('.promotion_info_list');
    GSAP.TweenMax.fromTo(graphic, 2,
        {
            xPercent: 20,
            scale: 2,
            alpha: 0
        },
        {
            xPercent: 0,
            scale: 1,
            alpha: 1,
            ease: GSAP.Power2.easeOut
        });
    GSAP.TweenMax.fromTo(product, 0.6,
        {
            alpha: 0,
            xPercent: -10
        },
        {
            delay: 0.3,
            alpha: 1,
            xPercent: 0,
            ease: GSAP.Power2.easeOut
        });
    GSAP.TweenMax.fromTo(productInfo, 0.6,
        {
            alpha: 0,
            xPercent: -10
        },
        {
            delay: 0.5,
            alpha: 1,
            xPercent: 0,
            ease: GSAP.Power2.easeOut
        });
    GSAP.TweenMax.fromTo(productInfoLabel, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.4,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });
    GSAP.TweenMax.fromTo(productInfoTitle, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.6,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });
    GSAP.TweenMax.fromTo(productInfoDesc, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.8,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });
    GSAP.TweenMax.fromTo(productInfoList, 0.6,
        {
            alpha: 0,
        },
        {
            delay: 1,
            alpha: 1,
            ease: GSAP.Power2.easeOut
        });
}


function resetPromoS2() {
    const graphic = promoS2.querySelector('.promotion_graphic');
    const product = promoS2.querySelector('.promotion_product');
    const productInfoTitle = promoS2.querySelector('.promotion_info_title');
    const productInfoList = promoS2.querySelector('.promotion_info_list');

    GSAP.TweenMax.set(graphic, {
        xPercent: -50,
        scale: 2,
        alpha: 0
    });
    GSAP.TweenMax.set(product, {
        rotation: 30,
        scale: 2,
        alpha: 0
    });
    GSAP.TweenMax.set(productInfoTitle, {
        alpha: 0,
        yPercent: 50
    });
    GSAP.TweenMax.set(productInfoList, {
        alpha: 0,
    });
}

function transitionInPromoS2() {
    const graphic = promoS2.querySelector('.promotion_graphic');
    const product = promoS2.querySelector('.promotion_product');
    const productInfoTitle = promoS2.querySelector('.promotion_info_title');
    const productInfoList = promoS2.querySelector('.promotion_info_list');

    GSAP.TweenMax.fromTo(graphic, 2,
        {
            xPercent: -50,
            scale: 2,
            alpha: 0
        },
        {
            xPercent: 0,
            scale: 1,
            alpha: 1,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(product, 1,
        {
            rotation: 30,
            scale: 2,
            alpha: 0
        },
        {
            delay: 0.3,
            rotation: 0,
            scale: 1,
            alpha: 1,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productInfoTitle, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.6,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });
    GSAP.TweenMax.fromTo(productInfoList, 0.6,
        {
            alpha: 0,
        },
        {
            delay: 0.8,
            alpha: 1,
            ease: GSAP.Power2.easeOut
        });
}

function resetPromoS3() {
    const graphic = promoS3.querySelector('.promotion_graphic');
    const product = promoS3.querySelector('.promotion_product');
    const productInfo = promoS3.querySelector('.promotion_product_info');
    const productInfoTitle = promoS3.querySelector('.promotion_info_title');
    const productInfoDesc = promoS3.querySelector('.promotion_info_desc');
    const productInfoList = promoS3.querySelector('.promotion_info_list');
    GSAP.TweenMax.set(graphic, {
        yPercent: -50,
        scale: 2,
        alpha: 0
    });
    GSAP.TweenMax.set(product, {
        alpha: 0,
        xPercent: -10
    });
    GSAP.TweenMax.set(productInfo, {
        alpha: 0,
        xPercent: -10
    });
    GSAP.TweenMax.set(productInfoTitle, {
        alpha: 0,
        yPercent: 50
    });
    GSAP.TweenMax.set(productInfoDesc, {
        alpha: 0,
        yPercent: 50
    });
    GSAP.TweenMax.set(productInfoList, {
        alpha: 0,
    });
}

function transitionInPromoS3() {

    const graphic = promoS3.querySelector('.promotion_graphic');
    const product = promoS3.querySelector('.promotion_product');
    const productInfo = promoS3.querySelector('.promotion_product_info');
    const productInfoTitle = promoS3.querySelector('.promotion_info_title');
    const productInfoDesc = promoS3.querySelector('.promotion_info_desc');
    const productInfoList = promoS3.querySelector('.promotion_info_list');
    GSAP.TweenMax.fromTo(graphic, 2,
        {
            yPercent: -50,
            scale: 2,
            alpha: 0
        },
        {
            yPercent: 0,
            scale: 1,
            alpha: 1,
            transformOrigin: '50% 50%',
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(product, 0.6,
        {
            alpha: 0,
            xPercent: -10
        },
        {
            delay: 0.3,
            alpha: 1,
            xPercent: 0,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productInfo, 0.6,
        {
            alpha: 0,
            xPercent: -10
        },
        {
            delay: 0.5,
            alpha: 1,
            xPercent: 0,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productInfoTitle, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.6,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productInfoDesc, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.8,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productInfoList, 0.6,
        {
            alpha: 0,
        },
        {
            delay: 1,
            alpha: 1,
            ease: GSAP.Power2.easeOut
        });
}


/*
* CTA
* */
const ctaSection = document.querySelector('.cta');
const ctaS1 = ctaSection.querySelector('.cta-s1');

function createCTAEffect() {
    const ctaS1 = ctaSection.querySelector('.cta-s1');
    let isS1In = false;
    const scenePromoS1 = new ScrollMagic.Scene({
        triggerElement: ctaS1,
        triggerHook: 0.7,
        duration: ctaS1.clientHeight
    })
        .on('enter', () => {
            if (!isS1In) {
                isS1In = true;
                transitionInCTAS1();
            }
        })
        .addTo(controller);

    resetCTAS1();
}

function resetCTAS1() {
    const graphic = ctaS1.querySelector('.cta_graphic');
    const productInfoLabel = ctaS1.querySelector('.cta_info_label');
    const productInfoTitle = ctaS1.querySelector('.cta_info_title');
    const productInfoDesc = ctaS1.querySelector('.cta_info_desc');
    const productButton = ctaS1.querySelector('.triggerButton');

    GSAP.TweenMax.set(graphic, {
        xPercent: 50,
        scale: 2,
        rotation: -15,
        alpha: 0
    });

    GSAP.TweenMax.set(productInfoTitle, {
        alpha: 0,
        yPercent: 50
    });

    GSAP.TweenMax.set(productInfoDesc, {
        alpha: 0,
        yPercent: 50
    });

    GSAP.TweenMax.set(productButton, {
        alpha: 0,
        yPercent: 50
    });

    GSAP.TweenMax.set(productInfoLabel, {
        alpha: 0,
        yPercent: 50
    });
}

function transitionInCTAS1() {

    const graphic = ctaS1.querySelector('.cta_graphic');
    const productInfoLabel = ctaS1.querySelector('.cta_info_label');
    const productInfoTitle = ctaS1.querySelector('.cta_info_title');
    const productInfoDesc = ctaS1.querySelector('.cta_info_desc');
    const productButton = ctaS1.querySelector('.triggerButton');

    GSAP.TweenMax.fromTo(graphic, 2,
        {
            xPercent: 50,
            scale: 2,
            rotation: -15,
            alpha: 0
        },
        {
            xPercent: 0,
            scale: 1,
            rotation: 0,
            alpha: 1,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productInfoTitle, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.5,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productInfoDesc, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.7,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productButton, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 0.9,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });

    GSAP.TweenMax.fromTo(productInfoLabel, 0.6,
        {
            alpha: 0,
            yPercent: 50
        },
        {
            delay: 1.1,
            alpha: 1,
            yPercent: 0,
            ease: GSAP.Power2.easeOut
        });
}